export default __webpack_public_path__ + "static/media/147-senior-residence.8ac9a700.svg";